import Input from '../../../form/Input';

interface IFranchiseInfo {
  companyName: string;
  ceo: string;
  telNo: string;
  companyNumber: string;
  mailOrderNumber: string;
  setMailOrderNumber: (value: string) => void;
  address: string;
  email: string;
  createdAt: string;
  updatedAt: string;
  bizProfileName: string;
}

const FranchiseInfo = ({
  companyName,
  ceo,
  telNo,
  companyNumber,
  mailOrderNumber,
  setMailOrderNumber,
  address,
  email,
  createdAt,
  updatedAt,
  bizProfileName,
}: IFranchiseInfo) => {
  return (
    <div className="my_franchise_info_wrapper">
      <h1 className="customer_detail_title">가맹점 정보</h1>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">가맹점명</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{companyName}</div>
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">대표자명</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{ceo}</div>
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">전화번호</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{telNo}</div>
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">주소</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{address}</div>
      </div>
        <div className="customer_detail_row">
            <h2 className="customer_detail_sub_title">이메일</h2>
            <div className="customer_detail_divide"></div>
            <div className="customer_detail_info">{email}</div>
        </div>
        <div className="customer_detail_row">
            <h2 className="customer_detail_sub_title">사업자등록번호</h2>
            <div className="customer_detail_divide"></div>
            <div className="customer_detail_info">{companyNumber}</div>
        </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">통신판매번호</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info" style={{ flex: 1 }}>
          <Input
            value={mailOrderNumber}
            onChange={e => setMailOrderNumber(e.target.value)}
            placeholder="통신판매번호를 입력하세요"
            width="100%"
            textAlign="left"
          />
        </div>
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">브랜드 명</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{bizProfileName}</div>
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">생성일</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{createdAt}</div>
      </div>
      <div className="customer_detail_row">
        <h2 className="customer_detail_sub_title">수정일</h2>
        <div className="customer_detail_divide"></div>
        <div className="customer_detail_info">{updatedAt}</div>
      </div>
    </div>
  );
};

export default FranchiseInfo;
